/* 
Patalla perfil compuesta por un componente de ilusiona-react-components, que se trata de un formulario con los 
datos del usuario, con la posibilidad de modificarlos.
Response: es una varaible para comunicarse con FormUser.
 */

import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

import { GETTOKEN } from '../constants';

//REDUX
import { useSelector, useDispatch } from "react-redux";
import { loadingAction, logoutAction, setUserAction } from "../redux/actions/userActions";

//MODULE
import { FormUser } from "ilusiona-react-components";

//#region CSS
import { makeStyles } from "@material-ui/core/styles";
import Fade from "@material-ui/core/Fade";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
const useStyles = makeStyles(theme => ({
  root: {
    marginTop: "30px",
    display: "flex"
  }
}));
//#endregion

export default function Profile({ history }) {
  const classes = useStyles();

  const user = useSelector(state => state.user.user);

  const [response, setResponse] = useState({});

  const dispatch = useDispatch();

  //Es un callback para poder comunicar con Ilusiona-react-component
  //Para saber si el usuario ha sido registado, mail modificado para poder desloguear, cargando o modificiador
  useEffect(() => {
    const loading = loading => dispatch(loadingAction(loading));
    if ("loading" in response) {
      loading(response.loading);
    }
    if ("logout" in response) {
      const logout = () => dispatch(logoutAction());
      logout().then(() => {
        history.push("/email-modificado/" + response.logout);
        loading(false);
      });
    }
    if ("registered" in response) {
      history.push("/registrado/" + response.registered);
      loading(false);
    }
    if ("modified" in response) {
      let userC = JSON.parse(Cookies.get("iluUser"));
      userC = { ...userC, ...response.modified };
      Cookies.set("iluUser", userC, { expires: 1 });
      const setUser = user => dispatch(setUserAction(user));
      setUser(userC);
    }
  }, [dispatch, history, response]);

  return (
    <div className={classes.root}>
      <Grid container spacing={2} justify="center" alignItems="center">
        <Fade in={true} timeout={1000}>
          <Grid container justify="center" alignItems="center" item xs={12}>
            <Grid item xs={12}>
              <Box textAlign="center">
                <Typography color="primary" variant="h4" data-lang="profile_title">
                  Perfil
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <FormUser
                dataUser={user}
                token={GETTOKEN()}
                setResponse={setResponse}
                options={{ isReadOnly: true }}
              />
            </Grid>
          </Grid>
        </Fade>
      </Grid>
    </div>
  );
}
